export interface IAppInfo {
    page: IPageInfo;
    server: IServerInfo;
    pathName: string;
    basePath: string;
    extractPath: string;
    site: string;
    segment: string;
    language: string;
    user: IUserInfo;
    environmentUrl?: string;
    domain?: IDomainInfo;
}

export interface IPageInfo {
    pageItemId: number;
    type: EPageType;
    isErrorPage: boolean;
}

export interface IServerInfo {
    hostName: string;
    host: string;
    origin: string;
}

export interface IUserInfo {
    id: string;
    roles: string[];
    isAuthenticated: boolean;
}

export interface IDomainInfo {
    edit: boolean;
    preview: boolean;
    www: boolean;
}

export enum EPageType {
    Unknown = '',
    CountrySelectionPage = 'CountrySelectionPage',
    LandingPageLight = 'LandingPageLight',
    SearchResultPage = 'SearchResultPage',
    ContactPage = 'ContactPage',
    ContactDetailPage = 'ContactDetailPage',
    ProductPage = 'ProductPage',
    ProductComparePage = 'ProductComparePage',
    ProductSelectionPage = 'ProductSelectorPage',
    Sitemap = 'Sitemap',
    HomePage = 'HomePage',
    AccountSettingsPage = 'AccountSettingsPage',
    HazmatPage = 'HazmatPage',
    DwBreathAhead = 'BreathAheadPage',
    DwVoiceSearchPage = 'DwVoiceSearchPage',
    DwVoiceHazmatPage = 'DwVoiceHazmatPage'
}
